export const getQuery = (_state, props) => props.location.query || null
export const getFromQuery = (_state, props) => key => props.location.query[key] || null
export const getFromQuery2 = key => (_state, props) => props.location.query[key] || null
export const getHash = (_state, props) => props.location.hash

export { getCity, getTimeData } from "./timetables"

export const getSelections = state => state.selections



// WEBPACK FOOTER //
// ./src/app/catalogo/selectors/index.js